import PropTypes from 'prop-types';
import { fetchPipelineStats } from '../../../network/fetches';
import React, { useState, useEffect, useRef } from 'react';

const ClientAttachmentsFilter = (props) => {
  const [pipelineStats, setPipelineStats] = useState(props.pipelineStats || {});
  const [showFilters, setShowFilters] = useState([]);
  const [error, setError] = useState(null);
  const prevFilters = useRef(showFilters)

  // Use useEffect to reset to default when filterData is empty
  useEffect(() => {
    if (prevFilters.current.length > showFilters.length){
      // If filters were removed, re-fetch stats to remove the effect of the removed filters
      filterClientAttachments();
    }
    prevFilters.current = showFilters; // Update the ref to the current filters
  }, [showFilters]);

  const filterClientAttachments = () => {
    const inputs = document.querySelectorAll('.client-attachments-filter');

    // Filter out empty values first, then create entries for Object.fromEntries
    const filterData = Object.fromEntries(
      [...inputs]
        .filter(input => input.value)
        .map(input => [input.name, input.value])
    );
    
    filterData["pipeline_stats[client_id]"] = props.clientId; // Ensure client_id is included

    fetchPipelineStats(filterData)
      .then((data) => {
        setPipelineStats(data);
      })
      .catch((error) => {
        setError(error)
      });
  }

  const enableFilter = (changeEvent) => {
    const value = changeEvent.target.value;
  
    if (showFilters.includes(value)) {
      // Remove the filter
      setShowFilters(showFilters.filter((item) => item !== value));
      filterClientAttachments(); // Re-fetch stats without the removed filter
    }
    else {
      // Add the filter
      setShowFilters([...showFilters, value]);
    }
  }

  const ensureBothDatesBeforeFilter = ()=> {
    const dateInputs = document.querySelectorAll('.client-attachments-filter-date-inputs');
    const bothValuesPresent = Array.from(dateInputs).every(input => input.value);
    if (bothValuesPresent) {
      filterClientAttachments();
    } else {
      setError(new Error('Please select both start and end dates before filtering.'));
    }
  }

  const attachmentsLink = (attachment_ids) => {
    const baseUrl = '/attachments?';
    const queryString = attachment_ids.map(id => `attachment_ids[]=${id}`).join('&');
    return baseUrl + queryString;
  }

  return (
    <>
      {/* Display error message if there is an error */}
      {error && (
        <div className="alert alert-danger">
          <strong>Error:</strong> {error.message  || 'An error occurred while fetching pipeline stats.'}
        </div>
      )}

      <div className="col-md-12">
        <label name="pipeline_stats" className="label label-default inline">Filter Attachments By:</label>
      </div>

        <div className="col-md-12 btn-group-xs" role="group">
          <button value="recruiter" className="btn btn-default" data-toggle="button" onClick={(e) => enableFilter(e)}>Recruiter</button>
          <button value="date" className="btn btn-default" data-toggle="button" onClick={(e) => enableFilter(e)}>Date</button>
          <button value="specialty" className="btn btn-default" data-toggle="button" onClick={(e) => enableFilter(e)}>Specialty</button>
        </div>
    
      {showFilters.includes('recruiter') && (
        <div className="col-md-12 form-group">
          <select
            className="form-control client-attachments-filter"
            name="pipeline_stats[recruiter_id]"
            id="filter_by_recruiter"
            onChange={filterClientAttachments}
          >
            <option value="" defaultValue="true">Choose a Recruiter</option>
            {props.recruiters.map((option) => (
              <option value={option.id} key={option.id} >
                {option.fullName}
              </option>
            ))}
          </select>
        </div>
        
      )}

      {showFilters.includes('date') && (
        <>
          <div className="col-md-6">
            <label className="label label-default inline client-attachments-filter">Start Date:</label>
            <input
              type="date" 
              className="form-control client-attachments-filter client-attachments-filter-date-inputs"
              name="pipeline_stats[start_date]"
              onChange={ensureBothDatesBeforeFilter}
            />
            
          </div>
          <div className="col-md-6">
            <label className="label label-default inline">End Date:</label>
            <input
              type="date" 
              defaultValue={new Date().toISOString().split("T")[0]}
              className="form-control client-attachments-filter client-attachments-filter-date-inputs"
              name="pipeline_stats[end_date]"
              onChange={ensureBothDatesBeforeFilter}
            />
          </div>
        </>
      )}

      {showFilters.includes('specialty') && (
        <div className="form-group col-md-12">
          <select
            className="form-control client-attachments-filter"
            name="pipeline_stats[specialty]"
            onChange={filterClientAttachments}
          >
            <option value="" defaultValue="true">Choose a Specialty</option>
            {props.specialties.map((option) => (
              <option value={option} key={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="col-md-12">
        <div>
          <table className="table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {pipelineStats && (
                Object.entries(pipelineStats).map(([statName, statValue]) => (
                  <tr key={statName}>
                    <td><a href={attachmentsLink(statValue)}>{statName}</a></td>
                    <td>{statValue.length}</td>
                  </tr>
                ))
              )}
              <tr className="success">
                <td><strong>Total Filtered Attachments</strong></td>
                <td><strong>{pipelineStats && Object.values(pipelineStats).flat().length}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> 
    </>
  );
};

ClientAttachmentsFilter.propTypes = {
  recruiters: PropTypes.object.isRequired, // this is passed from the Rails view
};

export default ClientAttachmentsFilter;
